<cp-autocomplete #autocomplete
				 [placeholder]="'Search'"
				 [minChars]="1"
				 [data]="source"
				 [filter]="filter"
				 (dataChange)="dataChange($event)">
	<ng-template #autocompleteHeaderTemplate>
		MyHeader
	</ng-template>

	<div>
		myContent
	</div>

	<ng-template #autocompleteItemTemplate  let-dataItem let-index="index">
		 {{index}} {{dataItem}}
	</ng-template>

	<ng-template #autocompleteNoDataTemplate >
		NoData
	</ng-template>
</cp-autocomplete>
